import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { QueryBuilderService } from 'src/app/services/query-builder.service';


export interface Category {
  value: any;
  viewValue: string;
}

export interface Sorting {
  value: any;
  viewValue: string;
}

export interface Operator {
  value: any;
  viewValue: string;
}



@Component({
  selector: 'app-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.scss']
})
export class TextSearchComponent implements OnInit {

  queryText: string;

  categories: Category[] = [
    { value: ['_all'], viewValue: 'Volltext' },
    { value: [
      '8_analyse_personen',
      '5_analyse_personen',
      '6_vw_gen_probanden.content'
    ], viewValue: 'Personen' },
    { value: [
      '5_us_probandid',
      '8_ps_id'], viewValue: 'Proband ID' },
    { value: [
      '2_analyse_schlagwoerter',
      '3_analyse_schlagwoerter',
      '4_analyse_schlagwoerter',
      '5_analyse_schlagwoerter',
      '8_analyse_schlagwoerter'
    ], viewValue: 'Schlagwörter' },
    { value: ['5_iw_themen.content'], viewValue: 'Themen' },
  ];
  selectedCategory = this.categories[0].value;
  selectedCategoryViewValue = this.categories[0].viewValue;

  // TODO if value:personen = personen dann selectedCategory['8_analyse_personen', '5_analyse_personen']

  sortings: Sorting[] = [
    { value: 'relevance', viewValue: 'Relevanz' },
  ];
  selectedSorting = this.sortings[0].value;

  operators: Operator[] = [
    { value: 'phrase_prefix', viewValue: 'genau' },
    { value: 'and', viewValue: 'und' },
    { value: 'or', viewValue: 'oder' },
  ];
  selectedOperator = this.operators[0].value;

  @Input()
  count: number;

  // TODO: should be typed to the emit
  @Output()
  search: EventEmitter<any> = new EventEmitter<any>();

  constructor( private queryBuilder: QueryBuilderService ) { }

  ngOnInit() {
    if (this.queryBuilder.getCat() !== undefined) {
      this.selectedCategory = this.queryBuilder.getCat();
    }

    if (this.queryBuilder.getOpt() !== undefined) {
      this.selectedOperator = this.queryBuilder.getOpt();
    }

    if (this.queryBuilder.getSort() !== undefined) {
      this.selectedSorting = this.queryBuilder.getSort();
    }

    if (this.queryBuilder.getQuerytext() !== undefined) {
      this.queryText = this.queryBuilder.getQuerytext();
    }
  }

  onSelectCat(event) {
    this.queryBuilder.setCat(event.value);
  }

  onSelectOpt(event) {
    this.queryBuilder.setOpt(event.value);
  }

  onSelectSort(event) {
    this.queryBuilder.setSort(event.value);
  }

  onSearchChange(event) {
    // console.log(event);
    this.queryBuilder.setQuerytext(event);
  }

  submitSearch() {
    this.search.emit({
      queryText: this.queryText,
      category: this.selectedCategory,
      sorting: this.selectedSorting,
      operator: this.selectedOperator
    });
  }

}
